import mixinsCommit from '@/store/mixins/mixinsCommit'
export default {
  ...mixinsCommit,
  changeActionbar (state, payload) {
    state.actionbar = payload
  }
}
